import React from "react";
import { Checkbox, Typography } from '@material-ui/core';
import { FormControlLabel } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    brandCheckBox: {
        color: theme.palette.primary.main,
        '&.Mui-checked': {
            color: theme.palette.primary.main,
        },
        padding: 0,
        '& .MuiSvgIcon-root': {
            fontSize: '24px'
        },
        '& .MuiFormControlLabel-root': {
            margin: 0
        },
        marginRight: theme.spacing(1)
    },
    noPadding: {
        margin: 0,
        padding: 0,
        '& .MuiFormControlLabel-label': {
            margin: 0,
            padding: 0
        }
    },
    formControlLabel: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: '35px',
        justifyContent: 'flex-start'
    },
    disabled: {
        '&.Mui-disabled': {
            color: theme.palette.text.disabled
        }
    },
    label: {
        marginTop: '4px',
        color: 'white'
    },
}));

export function BrandCheckbox({ $value, disabled, reportBrandCheckBox, checked, ...props }) {
    const styles = useStyles();
    
    return ($value ?
        <FormControlLabel
            checked={$value[0]}
            onChange={e => $value[1](e.target.checked)}
            control={<Checkbox disabled={disabled} color="primary" className={styles.brandCheckBox} />}
            className={styles.noPadding}
            {...props}
        />
        :
        <FormControlLabel 
            checked={checked} 
            control={<Checkbox disabled={disabled} color="primary" className={styles.brandCheckBox} />} 
            className={styles.noPadding}
            {...props} 
        />
    );
}

export function BrandCheckboxWithLabel({ labelText, ...props }) {
    const styles = useStyles();
    
    return (
        <BrandCheckbox
            className={styles.formControlLabel}
            classes={{ disabled: styles.disabled, label: styles.label }}
            label={<Typography variant="body2">{labelText}</Typography>}
            {...props}
        />
    );
}